/**
 * Configuración del tablero (solo administradores), organizada por secciones.
 * Hoy: nombres de las prioridades y proyectos. La API es quien exige el permiso; aquí solo se oculta.
 */
import { useYo } from '../features/auth/sesion';
import { SeccionProyectos } from '../features/proyectos/SeccionProyectos';
import { SeccionPrioridades } from '../features/configuracion/SeccionPrioridades';

export function PaginaConfiguracion() {
  const yo = useYo();

  if (!yo.puedeAdministrar) {
    return (
      <main className="pagina">
        <h1>Configuración</h1>
        <p className="vacio">Esta sección es solo para administradores.</p>
      </main>
    );
  }

  return (
    <main className="pagina">
      <h1>Configuración</h1>
      <SeccionPrioridades />
      <SeccionProyectos />
    </main>
  );
}
